import React from "react";
import PropTypes from "prop-types";
import { Info } from "lucide-react";

import { UICallout } from "../../ui";

import "./CompanyStatusWarning.scss";

/** The warning card of the Deactivate and Activate company modals: a title and its bullets. */
const CompanyStatusWarning = ({ variant, title, items }) => (
  <UICallout
    variant={variant}
    hasBorder={false}
    className="company-status-warning"
    title={
      <span className="company-status-warning__title">
        <Info size={20} strokeWidth={2} aria-hidden />
        {title}
      </span>
    }
    description={
      <ul className="company-status-warning__items">
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    }
  />
);

CompanyStatusWarning.propTypes = {
  variant: PropTypes.oneOf(["error", "warning"]).isRequired,
  title: PropTypes.node.isRequired,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default CompanyStatusWarning;
